import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { delayDagMockMutation } from '@/entities/dag/api/_internal/dagMockDelay';
import { toggleDagBookmarkInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { ToggleDagBookmarkRequest, ToggleDagBookmarkResponse } from '@/entities/dag/domain/types';

export const toggleDagBookmarkApi = async ({
  dagUuid,
}: ToggleDagBookmarkRequest): Promise<ToggleDagBookmarkResponse> => {
  if (shouldUseDagMockApi()) {
    await delayDagMockMutation('fast');
    return toggleDagBookmarkInMockStore(dagUuid);
  }

  const response = await cycloneApiClient.post<ToggleDagBookmarkResponse>(`/dags/${dagUuid}/bookmark`);
  return response.data;
};
